import { SanityBanner, SanityBannerBlock } from '../../types/generated/graphql-types'
import { BannerProps } from '../components/blocks/Banner'
import { TwoColumnBannerProps } from '../components/blocks/TwoColumnBanner'
import { Breakpoints } from '../utilities/breakpoints'
import { notEmpty } from '../utilities/filters'
import { validImage } from '../utilities/imageFilters'
import { Presets } from '../utilities/imagePreset'
import { getImagePropsWithSources } from '../utilities/imagePropUtils'
import {
  mapSanityInternalLinkToInternalLink,
  mapSanityLinkToInternalExternalLink,
} from './LinkMapper'

export const sanityFundsBannerToBannerProps = (
  banner: SanityBannerBlock
): TwoColumnBannerProps => {
  // fall back to (deprecated) contentLink if link isn't set
  const buttonLink =
    banner.link?.pageReference || banner.link?.url
      ? mapSanityLinkToInternalExternalLink(banner.link)
      : {
          url: banner.contentLink?.page?.path ?? '',
          title: banner.contentLink?.page?.title ?? '',
        }

  return {
    mainTitle: banner.mainTitle ?? '',
    textTitle: banner.textTitle ?? undefined,
    textContent: banner.textContent ?? undefined,
    link: buttonLink,
    image: validImage(banner.backgroundImage)
      ? getImagePropsWithSources(
          banner.backgroundImage,
          {
            small: Presets.twoColumnBanner.small,
            medium: Presets.twoColumnBanner.medium,
            large: Presets.twoColumnBanner.large,
            extraLarge: Presets.twoColumnBanner.extraLarge,
          },
          Breakpoints.sm,
          Breakpoints.xl,
          Breakpoints.xxl
        )
      : undefined,
  }
}

export const sanityBannerToBannerProps = ({
  backgroundImage,
  boxLinks,
  buttonLink,
  buttonTitle,
  subtitle,
  textContent,
  title,
}: SanityBanner): BannerProps => ({
  buttonTitle: buttonTitle ?? undefined,
  buttonUrl: buttonLink?.page?.path ?? '',
  links: boxLinks?.filter(notEmpty)?.map(mapSanityInternalLinkToInternalLink) ?? [],
  subtitle: subtitle ?? undefined,
  text: textContent ?? undefined,
  title: title ?? '',
  backgroundImageProps: validImage(backgroundImage)
    ? getImagePropsWithSources(
        backgroundImage,
        {
          small: Presets.banner.small,
          medium: Presets.banner.medium,
          large: Presets.banner.large,
        },
        Breakpoints.sm,
        Breakpoints.xxl
      )
    : undefined,
})
